import styled, { CSSProp } from 'styled-components';

export const StyledParallaxImage = styled.img<{ customStyles?: CSSProp }>`
    transition: transform 0.05s linear;

    will-change: transform;

    ${(props) => props.customStyles}
`;
